import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./PumpStatus.module.scss"

import {
  useDisplayDate,
  useIsPumpStatusSensorNearlyExpired,
} from "src/hooks"
import type { DateTimeFormatOptions } from "src/types"

// formats a date-time string like "Jun 09, 2026" (locale-dependent)
const sensorExpirationFormat: DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "2-digit",
}

const dateOptions = {
  dateTimeFormatOptions: sensorExpirationFormat,
}

export interface Props extends ComponentPropsWithoutRef<"div"> {
  pumpStatus: PumpStatus;
  isSensorExpirationStale: boolean;
}

export const PumpSensorExpirationDate = forwardRef<HTMLDivElement, Props>(
  function PumpSensorExpirationDate(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      pumpStatus,
      isSensorExpirationStale,
      ...divProps
    } = props

    const { sensor_expiration: sensorExpiration } = pumpStatus
    const isSensorNearlyExpired = useIsPumpStatusSensorNearlyExpired(pumpStatus)

    const displayDate = useDisplayDate(dateOptions)
    const sensorExpirationDate = sensorExpiration === null || isSensorExpirationStale
      ? "---"
      : displayDate(sensorExpiration)

    return (
      <div
        {...divProps}
        className={classNames(
          divProps.className,
          isSensorNearlyExpired && !isSensorExpirationStale && styles.expiringText,
        )}
        ref={propRef}
      >
        {sensorExpirationDate}
      </div>
    )
  },
)
